module.exports = __webpack_public_path__ + "static/media/delete.e6671ecc.svg";